module.exports = __webpack_public_path__ + "img/Pantalla-Intermedio.ad333573.jpg";